<template>
  <FilterBox v-if="store.softwareDownloads?.filters">
    <div class="filter-box__header">
      <Button
        style-type="secondary"
        :disabled="!store.hasActiveFilters"
        @click="store.resetFilters"
      >
        {{ $textDictionary['pdp.filters.resetFiltersNone.label'] }}
      </Button>
    </div>
    <div class="filter-box__content">
      <AccordionComponent :open-multiple-items="true" :item-heading-level="4">
        <SoftwareCenterFilter
          v-for="facet of store.softwareDownloads.filters"
          :key="facet.name"
          :filter-items="facet.values"
          :filter-name="facet.name"
        />
      </AccordionComponent>
    </div>
  </FilterBox>
</template>

<script setup lang="ts">
import { useDownloadStore } from '~/stores/downloadStore/softwareDownloadStore';
import {
  AccordionComponent,
  FilterBox,
  Button
} from '@hypercodestudio/basler-components';
import SoftwareCenterFilter from './SoftwareCenterFilter.vue';

const { $textDictionary } = useNuxtApp();
const store = useDownloadStore();
</script>
